import React from "react";
import { Row, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

import styles from "./styles/CreateAccountPage.module.css";
import FormCreateAccount from "../../components/FormCreateAccount/FormCreateAccount";
const { Title } = Typography;

function CreateAccountPage() {
  return (
    <div className={styles.container}>
      <center>
        <div className={styles.content}>
          <Row align="middle" justify="space-between" style={{ marginTop: 20 }}>
            <Link to={-1}>
              <ArrowLeftOutlined style={{ fontSize: 20 }} />
            </Link>
            <Title level={3} style={{ textAlign: "right" }}>
              Create Account
            </Title>
          </Row>
          <FormCreateAccount />
        </div>
      </center>
    </div>
  );
}

export default CreateAccountPage;
